module.exports = {"HAS_ORDER_FILTER":false,"HAS_FIRST_NAME_FILTER":false,"HAS_LAST_NAME_FILTER":false,"HAS_PHONE_FILTER":true,"HAS_EMAIL_FILTER":true}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/customerList.json
// module id = 1369
// module chunks = 1